import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IoArrowForwardOutline } from "react-icons/io5";

import "./tour-detail.scss";
import TourPassangers from "./TourPassangers.jsx";
import { TourInfo, Attention, PaymentGateway } from "./Components";
import Payment from "./Payment";
import Helmet from "react-helmet";
import logo from "../assets/image/20211007_120244.jpg";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { getTourInfoForReserve, reserveTour } from "services/reserveTour";
import Swal from "sweetalert2";
import image from "../assets/image/jomesob.jpg";

export default function ReserveTour(props) {
  const history = useHistory();

  const { userInfo } = useContext(AuthenticationContext);

  const [load, setLoad] = useState(false);
  const [info, setInfo] = useState({
    title: "",
    type: "",
    startDate: "",
    startTime: "",
    startPlace: "",
    cover_pic: "",
  });
  const [payType, setPayType] = useState("online");
  const [payPrice, setPayPrice] = useState(0);
  const [wallet, setWallet] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [pastPassangers, setPastPassangers] = useState([]);
  const [price, setPrice] = useState({
    basePrice: 0,
    otherPrices: [],
    absolutePrice: { price: 0, state: true },
    reservation: false,
    reserveWithoutPrepayment: { state: false },
    reserveWithPrepayment: { state: false, price: 0 },
  });
  const [busType, setBusType] = useState();
  const [seats, setSeats] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState(0);
  const [rules, setRules] = useState(false);
  const [passangers, setPassangers] = useState([]);
  const [tourId, setTourId] = useState(-1);
  const [selectedGateway, setSelectedGateway] = useState(null);

  const changeSeats = (seats) => setSeats(seats);
  const changeBusType = (type) => setBusType(type);
  const changeSelectedGateway = (gateway) => setSelectedGateway(gateway);

  const addPassanger = (passanger) => {
    setPassangers([...passangers, passanger]);
  };

  const changePrice = (x) => {
    setPrice(x);
  };

  const changeRules = (x) => {
    setRules(x);
  };

  const pay = async () => {
    let number = "12".includes(busType) ? selectedSeats : passangers.length + 1;
    let res = await reserveTour(
      // userInfo.id,
      198,
      tourId,
      number,
      seats,
      busType,
      totalPrice,
      payPrice,
      payType,
      passangers
    );
    if (res) history.push(res?.url);
    else
      Swal.fire({
        title: "خطا!",
        text: "مشکلی در ثبت اطلاعات بوجود آمده است، لطفا بعدا تلاش کنید.",
        icon: "error",
        showConfirmButton: true,
      });
  };

  useEffect(() => {
    setLoad(true);
  });

  useEffect(() => {
    async function loadPage(id) {
      // let res = await getTourInfoForReserve(id, userInfo.id);
      let res = await getTourInfoForReserve(id, 198);
      setInfo(res.info);
      setSeats(res.seats);
      setBusType(res.busType);
      setPrice(res.prices);
      setPastPassangers(res.pastPassangers);
      setWallet(res.wallet);
      if (res.wallet !== false){
        setPayType("wallet")
      }
      setLoad(true);
    }

    let id = props.match.params.id;
    loadPage(id).catch((error) => {
      console.log(error);
    });
    setTourId(id);
  }, []);

  useEffect(() => {
    setPastPassangers(
      pastPassangers.filter(
        (value) => !passangers.some((val) => val.id == value.id)
      )
    );
  }, [passangers]);

  useEffect(() => {
    let sum = 0;
    for (const x in price) {
      if (x == "otherPrices") {
        sum += price.otherPrices.reduce((total, value) => {
          if (value.state) {
            return total + value.price;
          }
          return total;
        }, 0);
      }
      if (price[x].state && typeof price[x].price !== "undefined") {
        sum += price[x].price;
      }
    }
    setTotalPrice(sum);
  }, [price]);

  useEffect(() => {
    let number = "12".includes(busType) ? selectedSeats : passangers.length + 1;
    let finalPrice = totalPrice * number - wallet;
    setPayPrice(finalPrice > 0 ? finalPrice : 0);
  }, [totalPrice, wallet, selectedSeats]);

  return (
    <>
      <Helmet>
        <title>{info.title + " | "} جمه صب</title>
      </Helmet>
      {load ? (
        <div className="the-tour-reserve">
          <div className="the-image-container">
            <img
              className="the-image"
              alt="the tour"
              src={
                info.cover_pic != ""
                  ? `http://mvc.dade24.ir/${info.cover_pic}`
                  : image
              }
            />
          </div>
          <div className="the-container">
            <div className="w-100 d-flex justify-content-center">
              <div className="the-logo">
                <img alt="logo" src={logo} />
              </div>
            </div>
            <TourInfo info={info} />
            <Payment
              price={price}
              changePrice={changePrice}
              totalPrice={totalPrice}
            />
            <TourPassangers
              passangers={passangers}
              addPassanger={addPassanger}
              pastPassangers={pastPassangers}
              busType={busType}
              seats={seats}
              changeBusType={changeBusType}
              changeSeats={changeSeats}
              selectedSeats={selectedSeats}
              setSelectedSeats={setSelectedSeats}
            />
            <Attention rules={rules} changeRules={changeRules} />
            <PaymentGateway
              type={payType}
              changeType={setPayType}
              wallet={wallet}
              totalPrice={totalPrice}
              payPrice={payPrice}
              changeSelectedGateway={changeSelectedGateway}
            />
            <div className="buttons">
              <button className="btn btn-prrimary">
                <IoArrowForwardOutline
                  style={{ fontSize: "18px", marginLeft: "5px" }}
                />
                بازگشت
              </button>
              <button
                className="btn btn-prrimary"
                disabled={!rules || selectedGateway == null}
                onClick={pay}
              >
                پرداخت
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ fontSize: 30 }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
}
